module.exports = "pegasus_template/assets/column-6-basic.png";